<template>
  <div class="upload-page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="scss"></style>
